import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {MenuItem} from '@material-ui/core';
//ListItemIcon, ListItemText , Grid, Paper, Menu
///import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Container, Box} from '@material-ui/core'
//IconButton
import {Button, FormControl, Checkbox, TextField, InputLabel, Select } from '@material-ui/core';
//import {MoreVert} from '@material-ui/icons';
//import EditIcon from '@material-ui/icons/Edit';
//import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
//import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { isInteger } from '../../../api/validators';

class EditExternalNetworkGroupDialog_ extends React.Component{

    constructor(props){
        super(props)

        const {group, type} = this.props;
        console.log('EditExternalNetworkGroupDialog_')
        console.log('group')
        console.log(group)
        console.log('type')
        console.log(type)

        this.state = {
            group: group,
            type: type,
            errors:{
                GroupID: false,
                Name: false
            },
            changed: false,
        }

        this.handleInput = this.handleInput.bind(this)
        //this.handleFieldInput = this.handleFieldInput.bind(this)
        //this.handleAllowInput = this.handleAllowInput.bind(this)
    }

    handleSave(){
        if(this.checkForm()){
            let group =  {...this.props.group, ...this.state.group}

            console.log('EXTERNAL_NETWORK_GROUP_EDITOR_SAVE')
            console.log(group)

            this.props.onAction({
                type: 'EXTERNAL_NETWORK_GROUP_EDITOR_SAVE', 
                group: group
            })
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'EXTERNAL_NETWORK_GROUP_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'EXTERNAL_NETWORK_GROUP_EDITOR_CLOSE'})
        }
    }

    handleInput(event, index){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        
        let error = this.validate(event.target.name, val)
        let errors = {...this.state.errors, [event.target.name]: error}

        const group = {...this.state.group, [event.target.name]: val}
        this.setState({group: group, ...changed, errors: errors})
    }

    label(name){
        return name
    }

    validate(name, value){
        const {t} = this.props
        let errors = this.state.errors;
        let error = false

        switch(name){
            case 'Name':
                return value ? false : t('NameIsEmpty')
                break

            case 'GroupID':
                if(!value){
                    return t(name) + ': ' + t('ValueIsEmpty')
                }else{
                    return isInteger(value) ? false : t(name) + ': ' + t('IsNotInteger')
                }
                break
        }

        /*
        if(!this.state.template.Name){
            errors.Name = t('NameIsEmpty')
            error = true
        }else{
            errors.Name = false
        }
        */
        //this.setState({errors: errors})

        return error;
    }

    checkForm(){
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            console.log('check '+i)
            errors[i] = this.validate(i, this.state.group[i])
            console.log(errors[i])
            if(errors[i]){
                check = false
            }
        }
        console.log('errors')
        console.log(errors)
        this.setState({errors: errors})
        return check
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuAddItemClose(event){
        this.setState({menuAddAnchor: null});
        event.stopPropagation();
    }

    render(){
        const {t} = this.props

        console.log('this.state.group');
        console.log(this.state.group);

        const title = this.props.action==='add'?t('NewGroup'):t('EditGroup')

        const margin = {margin:'16px 0 8px 0'}
        
        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:400}}>

            <Box textAlign="center">
                <TextField name="Name"  margin="normal" 
                    style={{width: '100%'}}
                    label2={this.label('Name')}
                    label={this.state.errors.Name ? this.state.errors.Name : t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.group.Name}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="GroupID"  margin="normal"
                    style={{width: '100%'}}
                    label2={this.label('GroupID')}
                    label={this.state.errors.GroupID ? this.state.errors.GroupID : t('GroupID')}
                    autoComplete="new-password"
                    error={this.state.errors.GroupID!==false}
                    value={this.state.group.GroupID}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="left">
                <FormControl style={{...margin, width: '100%'}}>
                    <InputLabel htmlFor='Slot'>{t('Slot')}</InputLabel>
                    <Select
                        value={this.state.group.Slot}
                        onChange={this.handleInput}
                        inputProps={{name: 'Slot', id: 'Slot'}}
                        >
                        <MenuItem key="1" value={1}>Slot 1</MenuItem>
                        <MenuItem key="2" value={2}>Slot 2</MenuItem>
                        {this.state.type==2 ? /*hytera*/
                        <MenuItem key="0" value={0}>PseudoTrunc</MenuItem>
                        : null}
                    </Select>
                </FormControl>
            </Box>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditExternalNetworkGroupDialog = withTranslation()(EditExternalNetworkGroupDialog_);